/**
 * The pool row's "Sends with" cell: the gateway's static sender IDs as
 * chips, the AI's names as one badge — or the warning that it has none.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Sparkles } from 'lucide-react';

import type { SendsWith } from './sender-words';

/** `nowrap` keeps it on one line (a drop row, 20/10/2026). */
export const SendsWithCell: FC<{ value: SendsWith; max?: number; nowrap?: boolean }> = ({ value, max = 3, nowrap = false }) => {
  const shown = value.names.slice(0, max);
  const rest = value.names.length - shown.length;
  if (value.names.length === 0 && value.ai === null)
    return <span className="text-[11px] text-warning" title="No sender ID and no AI sender group — this gateway's drops would have no sender">no sender</span>;
  return (
    <span className={`flex min-w-0 items-center gap-1 ${nowrap ? 'flex-nowrap whitespace-nowrap' : 'flex-wrap'}`} aria-label="Sends with" title={[...value.names, value.ai !== null ? `AI · ${value.ai} names` : null].filter(Boolean).join(', ')}>
      {shown.map((name) => (
        <span key={name} className="rounded-md bg-muted px-1.5 py-0.5 font-mono text-[10.5px] tracking-wide">
          {name}
        </span>
      ))}
      {rest > 0 ? <span className="text-[10px] text-muted-foreground">+{rest}</span> : null}
      {value.ai !== null ? (
        <span className="inline-flex items-center gap-1 rounded-md bg-primary/10 px-1.5 py-0.5 text-[10.5px] font-medium text-primary">
          <Sparkles className="h-3 w-3" aria-hidden />
          AI · {value.ai}
        </span>
      ) : null}
    </span>
  );
};
